import { useTagFormValidator } from "src/hooks/useTagFormValidator";
import {
  applyAttributePatch,
  useTagAttributeMeta,
  useTagAttributeStores,
  useTagDisplayValueSync,
} from "./useTagAttributeForm.parts";

export const useTagAttributeForm = ({
  entityTag,
  tagTypeConfig,
  entityId,
  editMode,
  isNewTag,
}) => {
  const stores = useTagAttributeStores({ entityTag, tagTypeConfig, entityId });
  const includeTagLevelAttributes = editMode || isNewTag;
  const attributeValues = {
    ...stores.updatedAttributes,
    ...stores.updatedEntityTagAttributes,
  };

  const {
    onFieldUpdate,
    onFormSave,
    fieldToBeFocused,
    fieldsToShowInvalidity,
    clearFieldToBeFocused,
  } = useTagFormValidator({
    fields: attributeValues,
    tagType: tagTypeConfig,
    tagValue: {
      ...entityTag,
      attributes: attributeValues,
    },
    includeEntityAttributes: true,
    includeTagLevelAttributes,
  });

  const meta = useTagAttributeMeta(tagTypeConfig);
  useTagDisplayValueSync({
    nameAttrTypes: meta.nameAttrTypes,
    updatedAttributes: stores.updatedAttributes,
    separator: meta.separator,
    entityId,
    setDisplayValue: stores.setDisplayValue,
  });

  const patch = (id, value, isEntityTagAttr) =>
    applyAttributePatch({
      id,
      value,
      isEntityTagAttr,
      updatedAttributes: stores.updatedAttributes,
      updatedEntityTagAttributes: stores.updatedEntityTagAttributes,
      setUpdatedAttributes: stores.setUpdatedAttributes,
      setUpdatedEntityTagAttributes: stores.setUpdatedEntityTagAttributes,
      onFieldUpdate,
      clearFieldToBeFocused,
      setRequiredFieldsMessage: stores.setRequiredFieldsMessage,
    });

  return {
    displayValue: stores.displayValue,
    setDisplayValue: stores.setDisplayValue,
    updatedAttributes: stores.updatedAttributes,
    updatedEntityTagAttributes: stores.updatedEntityTagAttributes,
    requiredFieldsMessage: stores.requiredFieldsMessage,
    setRequiredFieldsMessage: stores.setRequiredFieldsMessage,
    includeTagLevelAttributes,
    attributeValues,
    onFormSave,
    fieldToBeFocused,
    fieldsToShowInvalidity,
    tagTypeName: meta.tagTypeName,
    hasDetails: meta.hasDetails,
    parsedDetails: meta.parsedDetails,
    parentTag: meta.parentTag,
    isDisplayValueEditable: meta.isDisplayValueEditable,
    readonlyAttrTypes: meta.readonlyAttrTypes,
    editableAttrTypes: meta.editableAttrTypes,
    uniqueAttrTypes: meta.uniqueAttrTypes,
    allAttributes: attributeValues,
    onDisplayValueChange: (e) => stores.setDisplayValue(e.target.value),
    onAttrValueChange: (type, isEntityTagAttr) => (e) =>
      patch(type, e.target.value, isEntityTagAttr),
    onSelectAttrValue: (id, isEntityTagAttr) => (option) =>
      patch(id, option ? option.value : undefined, isEntityTagAttr),
    onDateChange: (id, isEntityTagAttr) => (value) =>
      patch(id, value, isEntityTagAttr),
  };
};
